import { Button, Column, FullRow, Row, TextField, Typography } from 'seagull';
import { ArrowUpward } from 'seagull/icons';
import styles from "./HelpMeWriteTextField.module.scss";
import { ActionType, HelpMeWriteTextFieldTestIds } from "./HelpMeWriteTextField.types";
import PresetButton from "./PresetButton";

// const SUGGESTIONS = [
//     'Make it more sales-oriented',
//     'Make it more professional',
//     'Add more detail',
//     'Simplify the language',
//     'Make it more concise',
// ];

// const ROTATION_INTERVAL_MS = 3000;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HelpMeWriteTextField = _ref => {
  let {
    value,
    onChange: _onChange,
    onSubmit,
    onActionClick,
    isLoading = false,
    disabled = false
  } = _ref;
  // const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);

  // useEffect(() => {
  //     if (disabled || isLoading || value) {
  //         return;
  //     }

  //     const interval = setInterval(() => {
  //         setCurrentSuggestionIndex((prev) => (prev + 1) % SUGGESTIONS.length);
  //     }, ROTATION_INTERVAL_MS);

  //     return () => clearInterval(interval);
  // }, [disabled, isLoading, value]);

  const handleActionClick = action => {
    onActionClick === null || onActionClick === void 0 || onActionClick(action);
  };
  const handleSubmit = () => {
    _onChange('');
    onSubmit();
  };
  const actionButtons = [{
    type: ActionType.Formalize,
    onClick: () => handleActionClick(ActionType.Formalize)
  }, {
    type: ActionType.Polish,
    onClick: () => handleActionClick(ActionType.Polish)
  }, {
    type: ActionType.Elaborate,
    onClick: () => handleActionClick(ActionType.Elaborate)
  }, {
    type: ActionType.Shorten,
    onClick: () => handleActionClick(ActionType.Shorten)
  }];
  const isDisabled = disabled || isLoading;
  // const placeholder = isDisabled || value ? undefined : 'Make it more sales-oriented';

  return /*#__PURE__*/_jsxs(Column, {
    "data-testid": HelpMeWriteTextFieldTestIds.Root(),
    gap: 8,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.textFieldWrapper,
      children: [/*#__PURE__*/_jsx(TextField, {
        multiline: true,
        minRows: 2,
        maxRows: 4,
        value: value,
        onChange: e => _onChange(e.target.value)
        // placeholder={placeholder}
        ,
        disabled: isDisabled,
        "data-testid": HelpMeWriteTextFieldTestIds.TextField(),
        inputRootClass: styles.inputRoot
      }), /*#__PURE__*/_jsx("div", {
        className: styles.footer,
        children: /*#__PURE__*/_jsxs(FullRow, {
          justifyContent: "space-between",
          alignItems: "center",
          padding: 12,
          children: [/*#__PURE__*/_jsx(Row, {
            gap: 8,
            children: actionButtons.map(_ref2 => {
              let {
                type,
                onClick
              } = _ref2;
              return /*#__PURE__*/_jsx(PresetButton, {
                onClick: onClick,
                disabled: isDisabled,
                testId: HelpMeWriteTextFieldTestIds[type](),
                text: type
              }, type);
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: handleSubmit,
            disabled: isDisabled,
            "data-testid": HelpMeWriteTextFieldTestIds.SubmitButton(),
            prefixIcon: /*#__PURE__*/_jsx(ArrowUpward, {}),
            className: styles.submitButton
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: isDisabled ? 'secondary' : 'secondary',
      "data-testid": HelpMeWriteTextFieldTestIds.Footer(),
      children: "AI suggestions may not always be accurate. Review and tailor as needed."
    })]
  });
};
export default HelpMeWriteTextField;